import { Component, ViewChild, ElementRef, OnInit, OnDestroy, AfterViewInit, HostListener, Output, EventEmitter, NgZone, Renderer2, ChangeDetectionStrategy } from "@angular/core";

import { WorkspaceDetailBaseComponent } from "@mypxplat/xplat/features";
import { UserService, HelperService, WorkspaceService, WindowService, environment, EventBusService, CommunityService, Notification, ContentService, NotificationService } from "@mypxplat/xplat/core";
import { AngularFirestoreCollection, AngularFirestore, AngularFirestoreDocument } from "@angular/fire/compat/firestore";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { AppService, AvoService, FirebaseService, WebCommunityService } from "@mypxplat/xplat/web/core";
import { WorkspaceUploadComponent, ManageCollaboratorsComponent, AddWorkspaceComponent, EditCommentComponent, CreatePublicLinkComponent } from "../modals";
import { take, filter, map, takeUntil } from "rxjs/operators";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { FileUploader } from "ng2-file-upload";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { MessageInputComponent } from "../message-input/message-input.component";
import { WorkspaceFilesComponent } from "../workspace-files/workspace-files.component";
import { triggerFileDownload } from "../../../utils/download-file";
declare var window: any;

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-shared-workspace-detail",
  templateUrl: "workspace-detail.component.html",
  standalone: false,
})
export class WorkspaceDetailComponent extends WorkspaceDetailBaseComponent implements OnInit, OnDestroy {
  // @HostListener("window:beforeunload", ["$event"])
  // doSomething($event) {
  //   this.timelineRef.update({
  //     viewing: firebase.firestore.FieldValue.arrayRemove(this.userService.user.id),
  //     typing: firebase.firestore.FieldValue.arrayRemove(this.userService.user.id),
  //   });
  // }

  public loading: boolean = false;
  public descriptionExpanded: boolean = false;
  public selectedView: "timeline" | "files" | "details" = "timeline";
  public firestore: AngularFirestoreCollection;
  public messagesRef: AngularFirestoreCollection;
  public missedMessagesRef: AngularFirestoreCollection;
  public timelineRef: AngularFirestoreDocument<any>;
  public loadingTimeline: boolean = true;

  public refreshFileDone: boolean = true;
  public shouldShowShowMore: boolean = false;
  public playingAudioFile: any;
  private _isListeningToEnded: boolean = false;

  public displayedSection = "timeline";
  public timelineFilesViewHeight: number = 100;
  public uiMeasured: boolean = false;
  public cachedUserID: any;
  public activeUsers: any = {};
  public typingUsers: any;
  public hasBaseDropZoneOver: boolean = false;
  public routerEvents: any;
  public batchOperationMode: boolean = false;

  public isChrome: boolean = false;
  public showingAllMessages: boolean = false;
  // `attingCollabs` / `highlightedAtCollab` / `selectedAtCollab` were leftovers from
  // an earlier mention implementation and were never assigned. The picker owns that now.
  public selectedAtCollabsInMessage: any = {};
  public fileRefs: any = {};
  public unReadCounts: any = {};
  public totalUnreadFileMessages: number;

  public inputContainerHeight: number = 44;
  public inputCmp: MessageInputComponent;
  public msgInputMargin: number = 0;
  public detailsWidth: string = "40%";
  public rightOffset: number;

  public hasMessagesPermission: boolean = false;

  @ViewChild("msgInput", { static: false }) msgInput: ElementRef;

  @Output() workspaceLoaded: EventEmitter<any> = new EventEmitter();

  @ViewChild("container", { static: false }) container: ElementRef;
  @ViewChild("chatWindow", { static: false }) chatWindow: ElementRef;
  @ViewChild("timelineFilesView", { static: false }) timelineFilesView: ElementRef;
  @ViewChild("descTextSpan", { static: false }) descTextSpan: ElementRef;
  @ViewChild("workspaceFilesCmp", { static: false }) workspaceFilesCmp: WorkspaceFilesComponent;

  public uploader: FileUploader;
  public activeFolder: any;
  public newFileMode: boolean = true;
  constructor(
    public windowService: WindowService,
    public userService: UserService,
    public helperService: HelperService,
    private _activatedRoute: ActivatedRoute,
    public workspaceService: WorkspaceService,
    public appService: AppService,
    public db: AngularFirestore,
    public fbAuth: AngularFireAuth,
    private _eventbusService: EventBusService,
    public router: Router,
    public zone: NgZone,
    public translate: TranslateService,
    public spinner: NgxSpinnerService,
    public communityService: WebCommunityService,
    public avoService: AvoService,
    public fbService: FirebaseService,
    public contentService: ContentService,
    private notificationService: NotificationService,
    private renderer: Renderer2,
    private hostElementRef: ElementRef
  ) {
    super(userService, windowService, workspaceService, zone, communityService);
  }

  ngOnInit() {
    // Guard against the user not being loaded yet (e.g. a deep link / cold load before the
    // profile resolves). Reading `this.userService.user.id` directly crashed with
    // "Cannot read properties of undefined (reading 'id')" for real users on this route.
    if (this.userService.user) {
      this.cachedUserID = this.userService.user.id += "";
    }
    this.uploader = new FileUploader({
      isHTML5: true,
      method: "PUT",
      queueLimit: 1,
      autoUpload: false,
      disableMultipart: true,
      url: "",
    });
    if (this._activatedRoute.snapshot.params["id"]) {
      this.initView(this._activatedRoute.snapshot.params["id"]);
    }

    this._eventbusService.observe(this._eventbusService.types.playAudio).subscribe((result) => {
      this.measureUI();
    });

    // Workspace mentions rendered as chips but did nothing when clicked; the
    // delegated handler only existed on <myp-comment>.
    this._removeMentionClickListener = this.renderer.listen(this.hostElementRef.nativeElement, "click", (event) => this.handleMentionClick(event));
  }

  private _removeMentionClickListener: () => void;

  handleMentionClick(event: any) {
    const id = event && event.target && event.target.dataset ? event.target.dataset.mentionid : null;
    if (!id || id === "studio_one_experts") return;
    this.router.navigate(["/profile", id]);
  }

  decodeName(string) {
    return string ? decodeURIComponent(string) : string;
  }

  initView(id) {
    this.loading = true;
    this.workspaceService.getWorkspace(id).subscribe(
      (result) => {
        let hasAccess = false;
        result.collaborators?.forEach((item) => {
          if (item.user_id == this.user.id) hasAccess = true;
        });
        if (result.user_id == this.user.id) hasAccess = true;
        if (hasAccess) {
          this.loading = false;
          this.workspaceLoaded.next(result);
          this.setupWorkspace(result);

          const workspaceId = parseInt(result.id, 10);
          const page = this.avoService.getPageProperties({ pageName: "Workspace Detail" });
          const te = this.avoService.trackEvent();
          if (!environment.production) {
            console.log("[WorkspaceViewed] detail initView", {
              workspaceId: result.id,
              hasTe: !!te,
              hasWorkspaceViewed: !!(te && typeof te.workspaceViewed === "function"),
              avoInitted: this.avoService.avoInitted,
            });
          }
          if (te && typeof te.workspaceViewed === "function") {
            const extra = { name: "Workspace Detail", workspaceId, eventType: "create", interactionType: "viewed" };
            const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
            te.workspaceViewed(payload);
            if (!environment.production) {
              console.log("[WorkspaceViewed] workspaceViewed() called on detail load for workspaceId:", result.id);
            }
          } else if (!environment.production) {
            console.warn("[WorkspaceViewed] detail: Not calling - te or workspaceViewed missing");
          }

          const go = () => {
            this.selectView(this._activatedRoute.snapshot.params["view"]);
            if (this.workspace.firebase_timeline_id) {
              this.initMessages();
            } else {
              // /create a timeline for this project.
              if (this.userService.user.id == this.workspace.user_id) {
                const ref = this.fbService.collection("timelines");
                this.fbService
                  .handleFirestorePromise(() =>
                    ref.add({
                      created: new Date(),
                      workspace_id: this.workspace.id,
                      created_by: this.user.id,
                      contributors: {
                        [this.user.id]: true,
                      },
                    })
                  )
                  .then((doc) => {
                    this.workspaceService.updateWorkspace({ id: this.workspace.id, firebase_timeline_id: doc.id }).subscribe((result) => {
                      this.workspace.firebase_timeline_id = doc.id;
                      this.initMessages();
                    });
                  });
              }
            }
          };
          go();
        } else {
          alert("You do not have access to this workspace.");
        }
      },
      (error) => {
        this.appService.alertError(error);
        // this.router.navigate(["workspaces"]);
      }
    );
    window.scrollTo(0, 0);
  }

  @HostListener("window:resize", ["$event"])
  getScreenSize(event?) {
    this.measureUI();
  }

  setupWorkspace(details, includeStorage = true) {
    if (details.shared_files && details.shared_files.length) {
      details.image = details.shared_files.filter((item) => item.coverphoto)[0] ? details.shared_files.filter((item) => item.coverphoto)[0].url : null;
    }
    this.workspace = details;
    this.myWorkspace = this.workspace.user_id == this.user.id;
    this.windowService.setTimeout(() => {
      this.measureUI();
    }, 600);
    if (this.workspace.mainMix) {
      this.workspace.mainMix.creator = this.workspace.collaborators?.filter((item) => item.user_id == this.workspace.mainMix.user_id)[0];
    }
    this.collabsNotMe = [];
    this.workspace.collaborators?.forEach((item) => {
      this.collaboratorMap[item.user_id] = item;
      if (item.user_id != this.user.id && item.status === "approved") {
        this.collabsNotMe.push({
          id: item.user_id,
          name: item.name,
          photo: item.photo,
          email: item.email,
        });
      }
    });
    if (includeStorage) {
      this.userService.getStorageDetails(this.workspace.user_id).subscribe((result) => {
        this.userStorageDetails = result;
      });
    }
    this.myRole = this.workspace.collaborators?.filter((item) => item.user_id == this.user.id)[0]?.role;
    this.windowService.setTimeout(() => {
      if (this.descTextSpan && this.descTextSpan.nativeElement) {
        if (this.descTextSpan.nativeElement.offsetHeight > 60) {
          this.shouldShowShowMore = true;
        }
      }
    }, 500);
  }

  showImage(src) {
    this._eventbusService.emit(this._eventbusService.types.viewFullscreenImage, src);
  }

  measureUI() {
    if (this.timelineFilesView && this.timelineFilesView.nativeElement) {
      let offsetTop = this.timelineFilesView.nativeElement.getBoundingClientRect().y;
      const height = window.innerHeight - offsetTop;
      let body = document.getElementsByTagName("body")[0];
      const audioPlayerHeight = body.classList.contains("audio-playing") ? 60 : 0;
      // Space to leave under the panel. The files view still renders its upload
      // button as a sibling below, so it needs room for it. The timeline no
      // longer does — the composer moved inside the panel — so reserving the
      // same 70px there just left a dead gap above the bottom of the window.
      const spaceBelowPanel = this.selectedView == "files" ? 70 : 20;
      this.timelineFilesViewHeight = height - audioPlayerHeight - spaceBelowPanel;
      this.rightOffset = 115;
      if (window.innerWidth < 1200) {
        this.rightOffset = 65;
      }
      if (window.innerWidth < 601) {
        this.rightOffset = 35;
      }
      if (window.innerWidth < 401) {
        this.rightOffset = 30;
      }
      // if (this.container.nativeElement.offsetWidth == 1800) {
      this.msgInputMargin = window.innerWidth - this.container.nativeElement.offsetWidth - this.container.nativeElement.offsetLeft - 60;
      // } else {
      // this.msgInputMargin = 0;
      // }
      // `chatWidth` was measured here to size the composer, which sat outside the
      // message column. It is a flex child of that column now and sizes itself.
      this.uiMeasured = true;
    }
    if (window.innerWidth < 992) {
      this.detailsWidth = "100%";
    } else {
      this.detailsWidth = "40%";
    }
    // if (window.innerWidth < 500) {
    //   this.rightOffset = 20;
    // } else if (window.innerWidth < 600) {
    //   this.rightOffset = 50;
    // }
  }

  resendInvite(email, event) {
    event.stopPropagation();
    this.workspaceService.resendWorkspaceInvite(email, this.workspace.id).subscribe((result) => {
      alert("Invite resent!");
    });
  }

  collabClick(collab) {
    const profileId = this.userService.appId === "fender" && collab["fc-id"] ? collab["fc-id"] : collab.user_id;
    if (profileId) {
      this.router.navigate(["./profile", profileId]);
    }
  }

  watchTimelineEvents() {
    // Route the presence/typing listener through handleFirestoreObservable so a transient
    // Firestore permission-denied (which fires while the Firebase custom-token session is being
    // re-established) triggers a re-login + retry instead of surfacing as an unhandled
    // FirebaseError "Missing or insufficient permissions." The sibling message listener in
    // initMessages() already does this; watchTimelineEvents() was the one timeline read still
    // subscribing to snapshotChanges() directly with no error handler.
    // Bugsnag: https://app.bugsnag.com/fender-digital/presonus-sphere-web/errors/6abd862b991833fd090b5577
    this.fbService
      .handleFirestoreObservable(() =>
        this.timelineRef.snapshotChanges().pipe(
          map((timelineData: any) => {
            let data = timelineData.payload.data();
            let rtn = {
              ...data,
              key: timelineData.payload.id,
            };
            return rtn;
          })
        )
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (result) => {
          this.activeUsers = {};
          if (result.viewing && result.viewing.length) {
            result.viewing.forEach((item) => (this.activeUsers[item] = true));
          }
          this.typingUsers = result.typing && result.typing.length ? result.typing.filter((item) => item != this.user.id) : [];
        },
        error: () => {
          // handleFirestoreObservable re-logs the user in and retries on permission-denied; if
          // the session still can't be restored (or the user has logged out) it surfaces a
          // generic error here. Presence/typing is non-critical, so swallow it rather than
          // letting it reach Bugsnag as an unhandled rejection.
        },
      });
  }

  /** Ids of the file-uploaded messages already seen, so a new one can trigger a file refresh. */
  private seenUploadMessageIds: Set<string>;

  initMessages(all = false) {
    this.timelineRef = this.fbService.doc(`timelines/${this.workspace.firebase_timeline_id}`);
    this.watchTimelineEvents();
    this.fbService
      .handleFirestoreObservable(() => this.timelineRef.get().pipe(take(1)))
      .subscribe({
        next: (result) => {
          if (this.userService.user.id == this.workspace.user_id) {
            let existingContributors = result.data()?.contributors || {};
            let contributors = { ...existingContributors };
            this.workspace.collaborators?.forEach((item) => {
              if (item.user_id) contributors[item.user_id] = true;
            });
            if (result.data() && !result.data().viewingFix) {
              this.timelineRef.update({ viewingFix: true });
            }
            if (JSON.stringify(contributors) != JSON.stringify(existingContributors)) {
              this.timelineRef.update({ contributors });
            }
          }
        },
        error: (error) => {},
      });
    this.missedMessagesRef = this.fbService.collection(`timelines/${this.workspace.firebase_timeline_id}/missedMessages`);
    this.messagesRef = this.fbService.collection(`timelines/${this.workspace.firebase_timeline_id}/messages`, (ref) => {
      if (all) {
        this.showingAllMessages = true;
        return ref.orderBy("timestamp");
      } else {
        this.showingAllMessages = false;
        return ref.orderBy("timestamp").limitToLast(100);
      }
    });
    this.communityService
      .subscribeToComments(this.messagesRef, "asc")
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (result) => {
          this.hasMessagesPermission = true;
          this.windowService.setTimeout(() => {
            this.scrollChatToBottom();
            // this.setupMissedMessages();
            this.updateMyReadStatus();
          }, 1000);
          // Every chat message lands here, but only an upload changes the file list. Refetching
          // on each one re-downloaded and re-rendered the whole folder per message. The first
          // emission only records what's there: the files component fetches on its own init.
          const uploadIds = this.communityService.comments.filter((msg) => msg.type == "file-uploaded").map((msg) => msg.id);
          const hasNewUpload = !!this.seenUploadMessageIds && uploadIds.some((id) => !this.seenUploadMessageIds.has(id));
          this.seenUploadMessageIds = new Set(uploadIds);
          if (hasNewUpload && this.workspaceFilesCmp) this.workspaceFilesCmp.getFiles(false, true);
          this.loadingTimeline = false;
          this.scrollChatToBottom();
        },
        (error) => {
          this.loadingTimeline = false;
          if (this.helperService.retrieveErrorMessage(error) == "Missing or insufficient permissions.") {
            alert("You do not have permission to view messages in this workspace. If you believe this is an error, please contact support.");
            this.hasMessagesPermission = false;
          }
        }
      );
  }

  fileDeleted(file) {
    this.communityService.comments.forEach((item) => {
      if (item.file && item.file.id == file.id) {
        this.fbService.doc(`timelines/${this.workspace.firebase_timeline_id}/messages/${item.key}`).delete();
      }
    });
  }

  // setupMissedMessages() {
  //   this.sharedFiles.forEach((file) => {
  //     if (file.type != "folder") {
  //       this.fileRefs[file.id] = this.db.collection("timelines").doc(this.workspace.firebase_timeline_id).collection("fileThreads").doc(file.id.toString());

  //       // Check if the document exists
  //       this.fileRefs[file.id]
  //         .collection("missedMessages")
  //         .doc(this.user.id)
  //         .get()
  //         .subscribe((docSnapshot) => {
  //           if (docSnapshot.exists) {
  //             // Continue with handling the observable if the document exists
  //             this.fbService
  //               .handleFirestoreObservable(() =>
  //                 this.fileRefs[file.id]
  //                   .collection("missedMessages")
  //                   .doc(this.user.id)
  //                   .snapshotChanges()
  //                   .pipe(
  //                     takeUntil(this.destroy$),
  //                     map((c: any) => {
  //                       let data = c.payload.data();
  //                       let rtn = {
  //                         ...data,
  //                         key: c.payload.id,
  //                       };
  //                       return rtn;
  //                     })
  //                   )
  //               )
  //               .subscribe({
  //                 next: (result: any) => {
  //                   this.unReadCounts[file.id] = result && result.missedCount ? result.missedCount : 0;
  //                   this.totalUnreadFileMessages = 0;
  //                   for (var i in this.unReadCounts) {
  //                     this.totalUnreadFileMessages += this.unReadCounts[i];
  //                   }
  //                 },
  //                 error: (error) => {},
  //               });
  //           } else {
  //             // Handle the case where the document does not exist
  //             // For example, set a default value or skip
  //             this.unReadCounts[file.id] = 0;
  //           }
  //         });
  //     }
  //   });
  // }

  msgOptions(msg?, file?, event?) {
    if (event) event.stopPropagation();
    if (msg && msg.file) file = msg.file;
    let title = file ? file.filename : msg.message;
    if (file && file.grouping_id && this.contentService.groupedFilesMap[file.grouping_id])
      title =
        "Stem Upload from Studio One 5 (" +
        this.contentService.groupedFilesMap[file.grouping_id].length +
        " file" +
        (this.contentService.groupedFilesMap[file.grouping_id].length > 1 ? "s" : "") +
        ")";
    let args: any = {
      title: title,
      actions: [],
    };
    if ((!file && this.user.id == msg.author.id) || (file && !file.grouping_id && ((file && file.user_id == this.user.id) || !file || this.myWorkspace))) {
      args.actions.push(file ? "Edit File Description" : "Edit Message");
    }
    if (file) {
      if (!file.grouping_id && !file.mainmix && this.workspaceService.audioFiles[file.extension]) args.actions.push("Mark as Main Mix");
      if (!file.grouping_id) args.actions.push("Download File");
      if (!file.grouping_id) args.actions.push("Rename File");
      if (file.grouping_id) args.actions.push("Download Stems");
      args.actions.push("Move File");
      if (this.user.active_subscription && !file.grouping_id) args.actions.push("Share in Community");
      if (this.user.active_subscription && !file.grouping_id && !file.hash) args.actions.push("Create Shareable Link");
      if (file.hash) args.actions.push("View Public Share Page");
    }
    if (this.myWorkspace || this.myRole == "admin" || (msg && msg.author.id == this.user.id) || (this.myRole == "contributor" && file && file.user_id == this.user.id)) {
      args.actions.push(file ? (file.grouping_id ? "Delete Stems" : "Delete File") : "Delete Message");
    }
    this._eventbusService.emit(this._eventbusService.types.showActionChooser, args);
    this._eventbusService
      .observe(this._eventbusService.types.actionChosen)
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          if (result == "Edit Message" || result == "Edit File Description") {
            this.editMsg(msg, file);
          } else if (result == "Mark as Main Mix") {
            this.workspaceService.updateFile({ id: file.id, mainmix: true }).subscribe((result) => {
              if (this.workspaceFilesCmp) this.workspaceFilesCmp.getFiles(false, true);
            });
          } else if (result == "Download File" || result == "Download Stems") {
            this.downloadFile(false, file);
          } else if (result == "Delete Message") {
            this.deleteMsg(msg, file);
          } else if (result == "Delete File" || result == "Delete Stems") {
            this.workspaceFilesCmp.deleteFile(file);
          } else if (result == "Move File") {
            this.workspaceFilesCmp.showMoveFolder([file]);
          } else if (result == "Rename File") {
            let newName = prompt("Enter a new filename...", file.filename.split(".")[0]);
            if (newName) {
              newName = newName.replace(/[#+%><*?}{|$=`!:/]/g, "");
              let exists = false;
              this.sharedFiles.forEach((item) => {
                if (newName + "." + file.extension == item.filename && file.folder_id == item.folder_id) exists = true;
              });
              if (exists) {
                alert("A file with that name already exists in this folder.");
              } else {
                let args: any = {
                  id: file.id,
                  filename: newName + "." + file.extension,
                };
                if (!file.storage_id) args.storage_id = file.filename;
                this.workspaceService.updateFile(args).subscribe(() => {
                  if (this.workspaceFilesCmp) this.workspaceFilesCmp.getFiles(false, true);
                });
              }
            }
          } else if (result == "Share in Community") {
            this.communityService.attachingExistingFile = file;
            this.router.navigate(["community/channels/general"]);
          } else if (result == "Create Shareable Link") {
            this.createPublicLink(file);
          } else if (result == "View Public Share Page") {
            this.router.navigate(["share/" + file.hash]);
          }
        }
      });
  }

  createPublicLink(file) {
    const go = (file) => {
      if (file.formats && file.formats.length > 1) {
        let args: any = {
          title: "Which format would you like to share?",
          actions: [],
        };
        file.formats.forEach((item) => {
          if (!item.public_link) args.actions.push(item.extension.toUpperCase());
        });
        this._eventbusService.emit(this._eventbusService.types.showActionChooser, args);
        this._eventbusService
          .observe(this._eventbusService.types.actionChosen)
          .pipe(take(1))
          .subscribe((result) => {
            if (result) {
              file.formats.forEach((item) => {
                if (item.extension.toUpperCase() == result) {
                  const modalRef = this.appService.showModal(CreatePublicLinkComponent, { size: "am" });
                  modalRef.componentInstance.file = item;
                }
              });
            }
          });
      } else {
        const modalRef = this.appService.showModal(CreatePublicLinkComponent, { size: "am" });
        modalRef.componentInstance.file = file;
      }
    };
    if (file.format_grouping_id) {
      this.spinner.show();
      this.workspaceService.getFileDetails(file.id).subscribe((result) => {
        this.spinner.hide();
        go(result);
      });
    } else {
      go(file);
    }
  }

  deleteMsg(msg, file?) {
    if (msg.file) file = msg.file;
    if (file) {
      this.communityService.comments.forEach((item, index) => {
        if (item.file && item.file.id == file.id) this.messageDeleteIndex = index;
      });
      this.workspaceFilesCmp.deleteFile(file);
    } else if (confirm("Are you sure you want to remove this message? This cannot be undone.")) {
      this.communityService.comments.forEach((item, index) => {
        if (msg.key == item.key) this.messageDeleteIndex = index;
      });
      this.fbService.doc(`timelines/${this.workspace.firebase_timeline_id}/messages/${msg.key}`).delete();
    }
  }

  editMsg(msg, file?) {
    if (msg.file) file = msg.file;
    if (file) {
      let newFileDescription = prompt("Edit your message...", file.description || "");
      if (newFileDescription) {
        this.workspaceService.updateFile({ id: file.id, description: newFileDescription }).subscribe((result) => {
          if (this.workspaceFilesCmp) this.workspaceFilesCmp.getFiles(false, true);
        });
      }
    } else {
      const modalRef = this.appService.showModal(EditCommentComponent, { size: "lg" });
      modalRef.componentInstance.comment = { ...msg };
      modalRef.componentInstance.isHtmlComment = true;
      modalRef.componentInstance.collaborators = this.collabsNotMe;
      modalRef.result.then((result) => {
        let updateItem = this.communityService.comments.filter((item) => item.key == msg.key)[0];
        let updateData: any = { message: result.message, edited: true };
        if (result.mentions) updateData.mentions = result.mentions;
        this.fbService.doc(`timelines/${this.workspace.firebase_timeline_id}/messages/${updateItem.key}`).update(updateData);
      });
    }
  }

  manageCollaborators() {
    const modalRef = this.appService.showModal(ManageCollaboratorsComponent, { size: "lg" });
    modalRef.componentInstance.collaborators = this.workspace.collaborators;
    modalRef.componentInstance.workspace_id = this.workspace.id;
    modalRef.componentInstance.collaboratorAdded.pipe(take(1)).subscribe((addedCollaborator) => {
      if (addedCollaborator && addedCollaborator.id) {
        this.timelineRef.get().subscribe((result) => {
          let contributors = result.data().contributors;
          contributors[addedCollaborator.id] = true;
          this.timelineRef.update({ contributors });
        });
      }
      this.workspaceService.getWorkspace(this.workspace.id, true).subscribe((result) => {
        this.setupWorkspace(result);
      });
    });
  }

  downloadFile(event, file) {
    file.url = this.workspaceService.buildFileUrl(this.workspace.user_id, this.workspace.id, file);
    if (event) event.stopPropagation();
    if (file.type == "stems" && file.grouping_id) {
      let files = this.contentService.groupedFilesMap[file.grouping_id];
      let timeout = 0;
      files.forEach((item) => {
        timeout += 500;
        item.delay = timeout;
      });
      files.forEach((file) => {
        this.windowService.setTimeout(() => {
          this.triggerDownload(file);
        }, file.delay);
      });
    } else if (file.format_grouping_id) {
      let args: any = {
        title: "Which format would you like to download?",
        actions: [],
      };
      this.contentService.groupedFormatsMap[file.format_grouping_id].forEach((item) => {
        args.actions.push(item.extension.toUpperCase());
      });
      this._eventbusService.emit(this._eventbusService.types.showActionChooser, args);
      this._eventbusService
        .observe(this._eventbusService.types.actionChosen)
        .pipe(take(1))
        .subscribe((result) => {
          if (result) {
            this.contentService.groupedFormatsMap[file.format_grouping_id].forEach((item) => {
              if (item.extension.toUpperCase() == result) {
                this.triggerDownload(item);
              }
            });
          }
        });
    } else {
      this.triggerDownload(file);
    }
    const page = this.avoService.getPageProperties({ pageName: "Workspace Detail" });
    const te = this.avoService.trackEvent();
    if (te && typeof te.workspaceViewed === "function") {
      const extra = {
        name: "Workspace Detail",
        workspaceId: parseInt(this.workspace.id, 10),
        eventType: "file",
        interactionType: "downloaded",
      };
      const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
      te.workspaceViewed(payload);
    }
  }

  triggerDownload(file) {
    triggerFileDownload(file.url, file.filename);
  }

  selectFileForBatchOperation(file, event?) {
    if (event) event.stopPropagation();
    if (!this.workspaceService.batchOperationSelection) this.workspaceService.batchOperationSelection = {};
    file.selectedForBatchOperation = !file.selectedForBatchOperation;
    if (file.selectedForBatchOperation) {
      this.workspaceService.batchOperationSelection[file.id] = file;
    } else {
      delete this.workspaceService.batchOperationSelection[file.id];
    }
  }

  toggleBatchOperationMode() {
    this.batchOperationMode = !this.batchOperationMode;
    if (!this.batchOperationMode) {
      this.workspaceService.batchOperationSelection = {};
      for (var i in this.workspaceService.folderMap) {
        this.workspaceService.folderMap[i].files.forEach((item) => {
          item.selectedForBatchOperation = false;
        });
      }
    }
  }

  batchOperation(operation) {
    let files = [];
    for (var i in this.workspaceService.batchOperationSelection) {
      this.workspaceService.batchOperationSelection[i].selectedForBatchOperation = false;
      files.push(this.workspaceService.batchOperationSelection[i]);
    }
    if (!files.length) {
      alert("You did not select any files.");
    } else {
      this.workspaceService.batchOperationSelection = {};
      this.batchOperationMode = false;
      let timeout = 0;
      if (operation == "download") {
        files.forEach((item) => {
          timeout += 500;
          item.delay = timeout;
        });
        files.forEach((file) => {
          this.windowService.setTimeout(() => {
            this.downloadFile(false, file);
          }, file.delay);
        });
      } else if (operation == "move") {
        this.workspaceFilesCmp.showMoveFolder(files);
      } else if (operation == "delete") {
        this.workspaceFilesCmp.deleteBatchFiles(files);
      }
    }
  }

  selectView(view) {
    this.selectedView = view;
    this.activeFolder = undefined;
    this.router.navigate(["./workspaces/detail/" + this.workspace.id, view], {
      queryParams: this._activatedRoute.snapshot.queryParams,
    });
    this.windowService.setTimeout(() => {
      this.measureUI();
    }, 200);
    this.scrollChatToBottom();
  }

  editWorkspace() {
    const modalRef = this.appService.showModal(AddWorkspaceComponent);
    modalRef.componentInstance.editing = this.workspace;
    modalRef.componentInstance.workspaceSaved.pipe(take(1), takeUntil(this.destroy$)).subscribe((result) => {
      // The save (POST workspace/) response only carries name/description and omits the
      // collaborators array (that only comes from GET workspace/detail). Merge onto the
      // existing workspace so collaborators and other detail-only fields aren't wiped.
      this.setupWorkspace({ ...this.workspace, ...result });
    });
    modalRef.componentInstance.workspaceDeleted.pipe(take(1), takeUntil(this.destroy$)).subscribe((result) => {
      this.workspaceService.deleteWorkspace(this.workspace.id).subscribe((result) => {
        if (result.status == "success") {
          let notification = this.notificationService.createCollaborationWorkspaceDeleted(this.workspace);
          if (this.collabsNotMe.length) {
            let ids = [];
            this.collabsNotMe.forEach((collab) => {
              ids.push(collab.id);
            });
            if (ids.length) {
              this.notificationService
                .sendNotification({
                  notification: notification,
                  user_ids: ids,
                  clients: ["rollup", "mobile", "email"],
                })
                .subscribe();
            }
          }
          this.timelineRef.delete();
          this.timelineRef = null;
          this.helperService.goBack();
        } else {
          alert("Deleting the workspace failed, please contact support.");
        }
      });
    });
  }

  incrementUnreadCount() {
    this.workspaceService.getWorkspace(this.workspace.id, true).subscribe((result) => {
      // get the collaborator details again just in case a collaborator has left in the meantime.
      this.setupWorkspace(result, false);
      this.workspace.collaborators?.forEach((item) => {
        if (item.status == "approved") {
          if (item.user_id && item.user_id != this.userService.user.id) {
            const userMissedRef = this.fbService.doc(`timelines/${this.workspace.firebase_timeline_id}/missedMessages/${item.user_id}`);
            userMissedRef
              .get()
              .pipe(take(1))
              .subscribe((result: any) => {
                if (!result.data()) {
                  userMissedRef.set({
                    missedCount: 1,
                  });
                } else {
                  let count = result.data().missedCount;
                  userMissedRef.set({
                    missedCount: ++count,
                  });
                }
              });
          }
        }
      });
    });
  }

  addMessage() {
    if (this.newMsg) {
      let obj: any = {
        author: {
          id: this.user.id,
          photo: this.user.photoURL,
          name: this.user.firstName + " " + this.user.lastName,
        },
        user_id: this.user.id,
        type: "message",
        workspace_name: this.workspace.name,
        timestamp: new Date(),
      };

      // Mentions resolve last: finalizeMessage measures its character offsets
      // against the string it returns.
      const finalized = this.inputCmp.finalizeMessage(this.newMsg);
      this.newMsg = finalized.message;
      if (finalized.mentions.length) obj.mentions = finalized.mentions;
      this.inputCmp.selectedMentionsInMessage = [];

      obj.message = this.newMsg;
      let notification = this.notificationService.createCollaborationMessage("collaboration_new_message", this.user, this.newMsg, this.workspace);
      if (this.collabsNotMe.length) {
        let notMentionIds = [];
        this.collabsNotMe.forEach((collab) => {
          if (!obj.mentions || !obj.mentions.length) {
            notMentionIds.push(collab.id);
          } else {
            // only add the id to the notMentionIds array if its not present in the mentions array
            let found = false;
            obj.mentions.forEach((mention) => {
              if (mention.id == collab.id) found = true;
            });
            if (!found) notMentionIds.push(collab.id);
          }
        });
        if (notMentionIds.length) {
          // send the notification to users who were not mentioned, users who were mentioned should also get an email
          this.notificationService
            .sendNotification({
              notification: notification,
              user_ids: notMentionIds,
              clients: ["rollup", "mobile"],
            })
            .subscribe();
        }
      }
      if (obj.mentions && obj.mentions.length) {
        // send the notification to users who were mentioned, and include "email" in clients array
        let mentionIds = [];
        obj.mentions.forEach((mention) => {
          mentionIds.push(mention.id);
        });
        notification.title = this.user.firstName + " mentioned you in " + this.workspace.name;
        this.notificationService
          .sendNotification({
            notification: notification,
            user_ids: mentionIds,
            clients: ["rollup", "mobile", "email"],
          })
          .subscribe();
      }

      this.messagesRef.add(obj);
      this.newMsg = "";
      this.inputCmp.emptyInput();
      this.incrementUnreadCount();
      this.scrollChatToBottom();
      this.timelineRef.get().subscribe((result) => {
        let readStatus = result.data().readStatus;
        if (!readStatus) readStatus = Object.assign({}, result.data().contributors);
        for (var i in readStatus) {
          readStatus[i] = i == this.user.id ? true : false;
        }

        this.timelineRef.update({ readStatus });
      });
    }
  }

  updateMyReadStatus() {
    this.timelineRef
      .get()
      .pipe(take(1))
      .subscribe((result) => {
        let existingReadStatus = result.data().readStatus;
        let readStatus = existingReadStatus ? { ...existingReadStatus } : Object.assign({}, result.data().contributors);
        readStatus[this.user.id] = true;
        let readStatusHasChanged = JSON.stringify(readStatus) != JSON.stringify(existingReadStatus);
        let count = Object.entries(readStatus).length;
        let caughtUpCount = 0;
        let caughtUp = false;
        for (var i in readStatus) {
          if (readStatus[i]) {
            caughtUpCount++;
          }
        }
        if (caughtUpCount == count) caughtUp = true;
        let caughtUpStatusHasChanged = caughtUp != result.data().caughtUp;
        if (caughtUpStatusHasChanged || readStatusHasChanged) {
          const update = { readStatus, caughtUp };
          this.timelineRef.update(update);
        }
      });
    const myMissedRef = this.fbService.doc(`timelines/${this.workspace.firebase_timeline_id}/missedMessages/${this.userService.user.id}`);
    myMissedRef
      .get()
      .pipe(take(1))
      .subscribe((result: any) => {
        if (result.exists && result.data() && result.data().missedCount != 0) {
          myMissedRef.set({
            missedCount: 0,
          });
        }
      });
  }

  addFile(mainMix = false, coverPhoto = false, droppedFile = false) {
    if (this.myRole != "browser") {
      if (this.userStorageDetails && this.userStorageDetails.used > this.userStorageDetails.plan_total) {
        if (this.user.id == this.workspace.user_id) {
          alert("You have exceeded your Cloud Storage limit. Free up space by deleting unsused files.");
        } else {
          alert("The owner of this workspace has exceeded their Cloud Storage limit.");
        }
      } else {
        const modalRef = this.appService.showModal(WorkspaceUploadComponent, { size: "lg", ariaLabelledBy: "modal-title" });
        modalRef.componentInstance.workspace_id = this.workspace.id;
        if (this.workspaceFilesCmp?.selectedFolder?.id) modalRef.componentInstance.folder = this.workspaceFilesCmp.selectedFolder;
        modalRef.componentInstance.myWorkspace = this.workspace.user_id == this.user.id;
        modalRef.componentInstance.mainMix = mainMix;
        modalRef.componentInstance.coverPhoto = coverPhoto;
        modalRef.componentInstance.description = this.newMsg;
        if (droppedFile) modalRef.componentInstance.droppedFile = droppedFile;
        modalRef.componentInstance.uploadProgressUpdated.pipe().subscribe((result) => {
          const file = this.sharedFiles.filter((item) => item.id == result.file.id)[0];
          if (file) file.progress = result && result.progress ? result.progress : false;
        });
        modalRef.componentInstance.fileCreated.pipe(take(1)).subscribe((result) => {
          if (this.workspaceFilesCmp) this.workspaceFilesCmp.getFiles(false, true);
        });
        modalRef.componentInstance.fileUploadFinished.pipe(take(1)).subscribe((result) => {
          let obj = {
            author: {
              id: this.user.id,
              photo: this.user.photoURL,
              name: this.user.firstName + " " + this.user.lastName,
            },
            user_id: this.user.id,
            file: result,
            type: "file-uploaded",
            timestamp: new Date(),
          };
          this.messagesRef.add(obj);

          if (this.collabsNotMe && this.collabsNotMe.length) {
            this.workspaceService.notifyWorkspaceFileUploaded(result.id).subscribe();
          }

          this.incrementUnreadCount();
          this.refreshFileDone = false;
          this.userService.getStorageDetails().subscribe();
          this.workspaceService.getWorkspace(this.workspace.id, true).subscribe((details) => {
            this.refreshFileDone = true;
            this.windowService.setTimeout(() => {
              this.setupWorkspace(details);
            }, 1000);
          });
        });
      }
    }
  }

  playAudio(file, event?) {
    if (event) event.stopPropagation();
    this.contentService.loadingPlayId = file.id;
    let playlist = [];
    this.workspaceService.getFilesByFolderId(file.folder_id, this.workspace.id).subscribe((result: any) => {
      playlist = result.filter((item) => item.progress == 100 && this.workspaceService.audioFiles[item.extension]);
      playlist.sort((a, b) => (new Date(a.date_created) > new Date(b.date_created) ? 1 : -1));

      if (file.format_grouping_id) {
        let formats = this.contentService.groupedFormatsMap[file.format_grouping_id];
        if (formats && formats.length > 0) {
          // choose the smallest format to play.
          let smallestFile = formats.reduce((prev, current) => (prev.filesize < current.filesize ? prev : current));
          file = smallestFile;
        }
      }

      if (playlist.length && playlist.length > 1) file.playlist = playlist;
      this.contentService.loadingPlayId = undefined;
      this._eventbusService.emit(this._eventbusService.types.playAudio, {
        ...file,
        triggerElement: event?.target as HTMLElement,
      });
      const page = this.avoService.getPageProperties({ pageName: "Workspace Detail" });
      const te = this.avoService.trackEvent();
      if (te && typeof te.workspaceViewed === "function") {
        const extra = {
          name: "Workspace Detail",
          workspaceId: parseInt(this.workspace.id, 10),
          eventType: "create",
          interactionType: "played",
        };
        const payload = this.avoService.buildEventPayload<Record<string, any>>(page, extra, { omitNulls: true });
        te.workspaceViewed(payload);
      }
    });
  }

  pauseAudio() {
    const audioPlayer: HTMLAudioElement = document.getElementById("audio_player") as HTMLAudioElement;
    this.playingAudioFile.isPlaying = false;
    audioPlayer.pause();
  }

  changeImage() {
    this.addFile(false, true);
  }

  scrollChatToBottom() {
    this.windowService.setTimeout(() => {
      if (this.chatWindow && this.chatWindow.nativeElement) {
        this.chatWindow.nativeElement.scrollTop = this.selectedView == "files" ? 0 : this.chatWindow.nativeElement.scrollHeight;
      }
    }, 25);
  }

  scrollToTop() {
    this.windowService.setTimeout(() => {
      if (this.chatWindow && this.chatWindow.nativeElement) {
        this.chatWindow.nativeElement.scrollTop = 0;
      }
    }, 25);
  }

  fileOverBase(e) {
    this.hasBaseDropZoneOver = e;
  }

  droppedFile(args) {
    this.addFile(false, false, args);
    this.uploader.clearQueue();
  }

  fileItemClick(file) {
    if (!this.batchOperationMode) {
      this.router.navigate(["workspaces/file/" + file.id]);
    }
  }

  msgFileClick(msg) {
    // check if the file exists and navigate to it if it does.
    // if it doesnt, alert and delete this message.
    if (!this.batchOperationMode) {
      this.workspaceService.getFileDetails(msg.file.id).subscribe({
        next: (result) => {
          this.router.navigate(["workspaces/file/" + msg.file.id]);
        },
        error: (error) => {
          if (error.status == 404) {
            alert("This file has been deleted, this timeline event will be removed.");
            this.fbService.doc(`timelines/${this.workspace.firebase_timeline_id}/messages/${msg.key}`).delete();
          } else {
            this.appService.alertError(error);
          }
        },
      });
    }
  }

  messageContainerHeightChange(args) {
    this.inputContainerHeight = args;
    this.scrollChatToBottom();
  }

  messageValueChange(args) {
    this.newMsg = args;
  }

  messageInputCmpLoaded(args) {
    this.inputCmp = args.cmp;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this._removeMentionClickListener) this._removeMentionClickListener();
    this.communityService.comments = [];
    this.workspaceService.lastViewedFolder = undefined;
    this.totalUnreadFileMessages = 0;
    for (var i in this.unReadCounts) {
      this.totalUnreadFileMessages += this.unReadCounts[i];
    }
    if (this.totalUnreadFileMessages) {
      this.fbService.doc(`timelines/${this.workspace.firebase_timeline_id}/missedMessages/${this.user.id}`).set({
        missedCount: this.totalUnreadFileMessages,
      });
    }
    this.clearWatchFileProgress();
  }
}
